import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { graphql } from "gatsby"
import Layout from "components/Layout"
import ContentCard from "components/ContentCard"
import EventCard from "components/EventCard"
import VideoCard from "components/VideoCard"
import TextCard from "components/TextCard"
import SliderSection from "components/SliderSection"

const RenderBody = ({ home, meta }) => (
  <>
    <Helmet
      title={`Homepage`}
      titleTemplate={`%s | ${meta.title}`}
      meta={[
        {
          name: `description`,
          content: meta.description,
        },
        {
          property: `viewport`,
          content:
            "width=device-width, height=device-height, initial-scale=1.0, user-scalable=0, minimum-scale=1.0, maximum-scale=1.0",
        },
        {
          property: `og:title`,
          content: meta.title,
        },
        {
          property: `og:description`,
          content: meta.description,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: meta.author,
        },
        {
          name: `twitter:title`,
          content: meta.title,
        },
        {
          name: `twitter:description`,
          content: meta.description,
        },
      ].concat(meta)}
    />

    <SliderSection galleryImages={home.hero_gallery} title="hello" />

    {home.body.map((slice, i) => {
      switch (slice.type) {
        case "events":
          return (
            <EventCard
              key={i}
              subline=""
              title={slice.fields[0].event_title}
              description={slice.fields[0].event_description}
              thumbnail={slice.fields[0].event_image.url}
              events={slice.fields}
            />
          )
        case "video":
          return (
            <VideoCard
              key={i}
              subline=""
              title={slice.fields[0].video_title}
              description={slice.fields[0].video_description}
              videourl={slice.fields[0].video_url.url}
            />
          )

        case "image":
          return (
            <ContentCard
              key={i}
              subline=""
              title={slice.fields[0].image_title}
              description={slice.fields[0].image_description}
              thumbnail={slice.fields[0].image.url}
            />
          )

        case "text":
          return (
            <TextCard
              key={i}
              title={slice.primary.text_title}
              description={slice.primary.text}
            />
          )

        default:
          return ""
      }
    })}
  </>
)

export default ({ data }) => {
  //Required check for no data being returned
  const doc = data.prismic.allHomepages.edges.slice(0, 1).pop()
  const meta = data.site.siteMetadata
  if (!doc) return null

  return (
    <Layout>
      <RenderBody home={doc.node} meta={meta} />
    </Layout>
  )
}

RenderBody.propTypes = {
  home: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
}

export const query = graphql`
  {
    prismic {
      allHomepages {
        edges {
          node {
            hero_gallery {
              gallery_image
              image_title
            }
            body {
              ... on PRISMIC_HomepageBodyEvents {
                type
                label
                fields {
                  event_date
                  event_description
                  event_image
                  event_title
                }
              }
              ... on PRISMIC_HomepageBodyVideo {
                type
                label
                fields {
                  video_description
                  video_title
                  video_url {
                    ... on PRISMIC__FileLink {
                      url
                    }
                  }
                }
              }
              ... on PRISMIC_HomepageBodyImage {
                type
                label
                fields {
                  image
                  image_description
                  image_title
                }
              }
              ... on PRISMIC_HomepageBodyText {
                type
                label
                primary {
                  text
                  text_title
                }
              }
            }
          }
        }
      }
    }
    site {
      siteMetadata {
        title
        description
        author
      }
    }
  }
`
